/**
 * @generated SignedSource<<7663e858470b3e76e9cdee65fc5935fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RecommendationsTab_userProfile$data = {
  readonly analyticsId: number;
  readonly displayUsername: string;
  readonly receivedTestimonials: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly recommend: boolean;
      };
    }>;
  };
  readonly recommendationRequests: {
    readonly count: number;
  };
  readonly visitorCanEdit: boolean;
  readonly " $fragmentType": "RecommendationsTab_userProfile";
};
export type RecommendationsTab_userProfile$key = {
  readonly " $data"?: RecommendationsTab_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"RecommendationsTab_userProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecommendationsTab_userProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "analyticsId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUsername",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ReceivedTestimonialConnection",
      "kind": "LinkedField",
      "name": "receivedTestimonials",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ReceivedTestimonialEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Testimonial",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "recommend",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RecommendationRequestConnection",
      "kind": "LinkedField",
      "name": "recommendationRequests",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};

(node as any).hash = "f2b25f29cd6fa1c6b55b9a1b49b769bb";

export default node;
